import React from 'react';
import { Text } from '@forecast-it/design-system';
export function DateInvalidError({ dateError, textSize, marginTop, marginBottom }) {
    return dateError ? (React.createElement("div", { style: { marginTop: marginTop || '8px', marginBottom: marginBottom || '4px' } },
        React.createElement(Text, { size: textSize || '2', color: 'error' }, dateError))) : null;
}
